/** Same shape as `FaxInstructions` in Printing.ts (kept here to avoid circular imports). */

/** Coversheet widget config for DocLink when printing unsigned verbals from CERT. */
export const DEFAULT_UNSIGNED_VERBALS_DASHBOARD_PRINT_CONFIG = {
  DocLink: {
    view: 'Card'
  }
};
export const UNSIGNED_VERBALS_PRINT_SOURCE_SINGLE = 'Unsigned verbals';
export const UNSIGNED_VERBALS_PRINT_SOURCE_BULK_BY_PROVIDER = 'Unsigned verbals (bulk by provider)';
/** Same shape as `EmailInstructions` in Printing.ts (kept here to avoid circular imports). */

/**
 * Builds the JSON `data` object for POST /print-unsigned-verbals (before keycloak fields).
 * Enforces a flat DTO: the verbal list is always `unsignedVerbals` as an array;
 * `dashboardPrintConfig` and `sourceString` are siblings, never nested under `unsignedVerbals`.
 */
export function buildUnsignedVerbalsPrintPostData(input) {
  var _input$currentUser, _input$dashboardPrint, _input$sourceString;

  const {
    unsignedVerbals
  } = input;

  if (unsignedVerbals != null && typeof unsignedVerbals === 'object' && !Array.isArray(unsignedVerbals) && Array.isArray(unsignedVerbals.unsignedVerbals)) {
    throw new TypeError('printUnsignedVerbals: `unsignedVerbals` must be the array of verbal rows. ' + 'You passed the nested bundle `{ unsignedVerbals, dashboardPrintConfig, sourceString }` as `unsignedVerbals`. ' + 'Pass the array as `unsignedVerbals` and pass dashboardPrintConfig / sourceString as separate arguments.');
  }

  if (!Array.isArray(unsignedVerbals)) {
    throw new TypeError(`printUnsignedVerbals: \`unsignedVerbals\` must be an array; received ${unsignedVerbals === null ? 'null' : typeof unsignedVerbals}.`);
  }

  const body = {
    agency: input.agency,
    currentUser: input.currentUser,
    siteTimezone: (_input$currentUser = input.currentUser) === null || _input$currentUser === void 0 ? void 0 : _input$currentUser.siteTimezone,
    dashboardPrintConfig: (_input$dashboardPrint = input.dashboardPrintConfig) !== null && _input$dashboardPrint !== void 0 ? _input$dashboardPrint : DEFAULT_UNSIGNED_VERBALS_DASHBOARD_PRINT_CONFIG,
    sourceString: (_input$sourceString = input.sourceString) !== null && _input$sourceString !== void 0 ? _input$sourceString : UNSIGNED_VERBALS_PRINT_SOURCE_SINGLE,
    unsignedVerbals
  };
  if (input.patient) body.patient = input.patient;
  if (input.faxInstructions) body.faxInstructions = input.faxInstructions;
  if (input.emailInstructions) body.emailInstructions = input.emailInstructions;
  return body;
}